import Header from "@/components/Header";
import AdBanner from "@/components/AdBanner";
import Hero from "@/components/Hero";
import FeaturedVehicles from "@/components/FeaturedVehicles";
import LatestVehicles from "@/components/LatestVehicles";
import Stock from "@/components/Stock";
import ImportService from "@/components/ImportService";
import Financing from "@/components/Financing";
import WhyUs from "@/components/WhyUs";
import Testimonials from "@/components/Testimonials";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white text-slate-900 antialiased">
      <Header />
      <main>
        <AdBanner />
        <Hero />
        <FeaturedVehicles />
        <LatestVehicles />
        <Stock />
        <ImportService />
        <Financing />
        <WhyUs />
        <Testimonials />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
